import { useState } from 'react';
import type { Api } from '../api.js';
import { type TYPE_LABELS, today } from './types.js';
import { useOrgData } from './useOrgData.js';

interface Row {
  accountId: string;
  code: string;
  name: string;
  type: keyof typeof TYPE_LABELS;
  balance: string;
}

const debit = (b: string) => (b.startsWith('-') ? '' : b);
const credit = (b: string) => (b.startsWith('-') ? b.slice(1) : '');

export function TrialBalance({ api, orgId }: { api: Api; orgId: string }) {
  const [asAt, setAsAt] = useState(today());
  const { data, error } = useOrgData<{ rows: Row[]; total: string; currency: string }>(
    api,
    orgId,
    `/trial-balance?asAt=${asAt}`,
  );
  return (
    <section className="stack">
      <div className="title-row">
        <h2>Trial balance</h2>
        <label className="inline">
          As at
          <input
            type="date"
            value={asAt}
            onChange={(e) => e.target.value && setAsAt(e.target.value)}
          />
        </label>
      </div>
      {error && <p className="error">{error}</p>}
      {data && (
        <table className="table">
          <thead>
            <tr>
              <th>Code</th>
              <th>Account</th>
              <th className="num">Debit</th>
              <th className="num">Credit</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={r.accountId}>
                <td>{r.code}</td>
                <td>{r.name}</td>
                <td className="num">{debit(r.balance)}</td>
                <td className="num">{credit(r.balance)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={2}>Difference ({data.currency})</td>
              <td colSpan={2} className={`num ${data.total === '0.00' ? '' : 'error'}`}>
                {data.total}
              </td>
            </tr>
          </tfoot>
        </table>
      )}
    </section>
  );
}
